import { Box, Button, Tile, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { useHistory } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"

export function AirwallexKycHero(): JSX.Element {
  const history = useHistory()

  const { data } = useQuery(["airwallexKycStatus"], () => carrotClient.getAirwallexKycStatus())
  const inProgress = data?.status === "InProgress"

  const handleClick = () => {
    history.push("/awx/kyc")
  }

  return (
    <Tile
      component={Box}
      display="flex"
      border={(theme) => `2px solid ${theme.palette.background.paper}`}
      borderRadius={(theme) => theme.tokens.borderRadius.sm}
      color="info"
    >
      <Box
        display="flex"
        flexDirection="column"
        paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}
        paddingTop={(theme) => theme.spacing(theme.tokens.spacing.xs)}
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      >
        <Typography variant="h4" color={(theme) => theme.palette.text.primary}>
          <FormattedMessage defaultMessage="Airwallex onboarding" />
        </Typography>
        <Typography variant="body1" color={(theme) => theme.palette.text.primary}>
          <FormattedMessage defaultMessage="Please answer a few questions to complete Airwallex onboarding. This is a required step to set up your organization's Carrot Card® account." />
        </Typography>
        <Box>
          <Button onClick={handleClick} color="secondary" variant="contained" fullWidth={false}>
            {inProgress ? (
              <FormattedMessage defaultMessage="Continue Airwallex KYC" />
            ) : (
              <FormattedMessage defaultMessage="Complete onboarding" />
            )}
          </Button>
        </Box>
      </Box>
    </Tile>
  )
}
